import { axiosInstance } from '../../../../../Interceptors/axiosInterceptor';
import ApiUrlConstant from '../../../../../Shared/Utils/UrlConstants';

const Service = {
  signup: (data) => {
    return axiosInstance.post(ApiUrlConstant.signupService(), data, { loaderKey: 'signup' });
  },
  // getIndustries: () => {
  //   return axiosInstance.get(ApiUrlConstant.industriesService(), { loaderKey: 'getIndustries' });
  // },
  login: (data) => {
    return axiosInstance.post(ApiUrlConstant.loginService(), data, { loaderKey: 'login' });
  },
  getPatientByEmail: (id) => {
    return axiosInstance.get(ApiUrlConstant.getPatientByEmail(id), { loaderKey: 'getPatientByEmail' });
  },
};

export default Service;
